import { App_Url_New } from "@/src_new/shared/common/static";
import { usePosterReducers } from "@/src_new/shared/redux/store/useGetData";
import AuthHeader from "@/src_new/shared/secured/components/AuthHeader";
import SideBar from "@/src_new/shared/secured/components/Sidebar";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom"; // Combined imports

const LOVABLE_URL = "https://commercial-bridge-pro.lovable.app";

export default function AuthLayout() {
  const {
    auth: { user },
  } = usePosterReducers();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pathname = useLocation().pathname;

  const isDashboardRoute = pathname === "/dashboard" || pathname === "/home";
  const isLeadsRoute = pathname.startsWith(App_Url_New.secured.frontlinks.leads);
  const isOpportunityRoute =
    pathname.startsWith("/opportunity") ||
    pathname.startsWith("/opportunities") ||
    pathname.startsWith(App_Url_New.secured.frontlinks.opportunitiesAdd);
  const isLeadDetailRoute = /^\/lead\/[^/]+$/.test(pathname);
  const isPipelineAnalyticsRoute = pathname.startsWith("/pipeline-analytics");
  const isRfqRoute = pathname.startsWith("/rfqs");
  const isFormConfigRoute = pathname.startsWith("/form-config");
  const isCommissionsRoute = pathname.startsWith("/commissions");

  return (
    <div className="h-screen flex overflow-hidden">
      <SideBar />

      <main className="flex-1 flex flex-col overflow-hidden">
        <AuthHeader />

        <div className="flex-1 overflow-auto thin-scrollbar m-2">
          {isLeadsRoute ||
          isLeadDetailRoute ||
          isOpportunityRoute ||
          isDashboardRoute ||
          isPipelineAnalyticsRoute ||
          isRfqRoute ||
          isFormConfigRoute ||
          isCommissionsRoute ? (
            <Outlet />
          ) : (
            <iframe
              src={
                pathname === "/dashboard"
                  ? `${LOVABLE_URL}/?embed=true`
                  : `${LOVABLE_URL}${pathname}?embed=true`
              }
              title="App"
              className="h-full w-full border-none"
            />
          )}
        </div>
      </main>
    </div>
  );
}
